// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { Icon } from '../../../atoms/Icon';
import { Subheading } from '../../../atoms/Subheading';
export var NavigationCardStructure = function (_a) {
    var leftIcon = _a.leftIcon, text = _a.text, className = _a.className, onClick = _a.onClick;
    return (React.createElement(Container, { role: 'navigation', className: className, onClick: onClick },
        React.createElement(Container, { height: '28px', marginBottom: 'auto' },
            React.createElement(Icon, { name: leftIcon, ariaLabel: leftIcon, styleVariant: 'blue' })),
        React.createElement(Container, { marginLeft: '8px', marginRight: '16px' },
            React.createElement(Subheading, { as: 'h3', size: 'medium' }, text)),
        React.createElement(Icon, { name: 'ChevronRight', ariaLabel: 'ChevronRight', styleVariant: 'grey' })));
};
//# sourceMappingURL=NavigationCardStructure.js.map